<template>
  <div class="commissionDatum">
    <!-- 销售佣金设定 标题 -->
    <div class="title">
      <label>
          <input type="checkbox" class="enable-btn" v-model="enable" :disabled="version=='0'">&nbsp;
          <span class="enable-text">{{multiLanguage.enable}}</span>
      </label>
      <span class="table-title">{{multiLanguage.salesCommissionSetting}} <span v-if="version=='1'">({{isConfirm ? multiLanguage.confirmed : multiLanguage.unconfirmed }})</span></span>
      <div class="btn-box pull-right">
        <button class="btn" v-if="version == '1'" @click="verify">
          <span class="glyphicon glyphicon-ok"></span>
          {{multiLanguage.btnGroup.check}}
        </button>
        <button class="btn" v-if="version == '1'" @click="submit">
          <span class="glyphicon glyphicon-edit"></span>
          {{multiLanguage.btnGroup.submit}}
        </button>
        <button class="btn" v-if="version == '1'" @click="pageInit('0')">
          <span class="glyphicon glyphicon-repeat"></span>
          {{multiLanguage.btnGroup.backData}}
        </button>
      </div>
      <div class="clear"></div>
    </div>
    <!-- 最后修改 and 最后审核   -->
    <div class="last-update-box">
      <span class="pull-left">{{multiLanguage.updateBy}} : {{updateBy}} ({{lastUpdate}})</span>
      <span class="pull-right" v-if="version == '0'">{{multiLanguage.confirmBy}} : {{confirmBy}} ({{lastConfirm}})</span>
      <div class="clear"></div>
    </div>
    <!-- 銷售的预设标准 -->
    <div class="cpa-switch-box">
        <div class="preinstall-box pull-right" :style="version == '0' ? 'visibility:hidden;' : ''">
          <Dropdown menu-right> 
            <button data-role="trigger" class="btn btn-default dropdown-toggle" type="button" :disabled="!enable || version == '0'">
                <span>{{multiLanguage.settingTemplate}}</span>
                <span class="caret"></span>
            </button>
            <template slot="dropdown">
              <li v-for="(item,index) in salesTemplate" v-if="item.isDisplay" @click="normSetFn(item.templateId)">
                <a role="button">{{multiLanguage[item.langKey]||item.templateId}}</a>
              </li>
            </template>
          </Dropdown>
        </div>
        <div class="clear"></div>
      </div>
    <div>
    </div>
    <!-- 规则设定 内容 -->
    <rule-setting
      :enable="enable"
      :multiLanguage="multiLanguage"
      :version="version"
      :relation="relation"
      :currentIB="currentIB"
      :viewBtn="viewBtn"
      :rule="rule"
      :ruleSeq="ruleSeq"
      ref="ruleSetting"
      @checkId="checkIdFn">
    </rule-setting>
    <!-- 特别代理 and 被忽视的代理 -->
    <special-and-overlook
      :enable="enable"
      :multiLanguage="multiLanguage"
      :version="version"
      :specialIB="specialIB"
      :overlookIB="overlookIB"
      :curArea="curArea"
      ref="specialAndOverlook">
    </special-and-overlook>
    <!-- 模态窗 -->
    <Modal v-model="showModal" size="sm" :header="false" :footer="false">
      <div v-show="!sucSave">
          <i class="glyphicon glyphicon-warning-sign color-red"></i>
          <span class="color-red">{{multiLanguage.submitResult.err}}</span>
      </div>
      <div v-show="sucSave">
          <i class="glyphicon glyphicon-ok color-green"></i>
          <span class="color-green">{{multiLanguage.submitResult.succeed}}</span>
      </div>
    </Modal>
  </div>
</template>

<script>
  var moment = require('moment');
  moment().format();
  import { getTimeDiff,updateTimeByUtc } from 'common/js/util'
  import ruleSetting from './ruleSetting'
  import specialAndOverlook from './specialAndOverlook'
  import { URL_SALESSET,URL_TOOLCHECKID,URL_DEFAULT } from 'api/commissionApi'
  import { Modal,Btn,Dropdown} from 'uiv'
  import { Api } from 'api/commissionEnv'
  var api = new Api()
  export default {
    props: {
      multiLanguage: {
        type: Object,
        default: {},
      },
      version: {
        type: String,
        default: '',
      },
      viewBtn: {
        type: String,
        default: '',
      },
      curArea: {
        type: String,
        default: ''
      },
    },
    components: {
      Modal,
      ruleSetting,
      specialAndOverlook,
      Btn,
      Dropdown
    },
    data() {
      return {
        UTCDIFF: getTimeDiff(),
        showModal: false,
        sucSave: false,
        enable: false,
        updateBy: '',
        confirmBy: '',
        lastUpdate: '',
        lastConfirm: '',
        relation: [],
        rule: [],
        currentIB:{},
        specialIB: [],
        overlookIB: [],
        isConfirm: false,
        ruleSeq: [],
        salesTemplate: null
      }
    },
    mounted () {
      this.pageInit(this.version)
    },
    computed: {
      updateData () { // 需要修改的数据
        let newRule = []
        if (!this.enable) {
          for (let ruleLevel of this.rule) {
            let newRuleLevel = []
            for (let ruleItem of ruleLevel) {
              if ((!ruleItem.enableCommTarget && ruleItem.value.trim() !== '') || (ruleItem.enableCommTarget && ruleItem.commTarget !== ''  && ruleItem.value.trim() !== '')) newRuleLevel.push(ruleItem)
            }
            newRule.push(newRuleLevel)
          }
        }
        let specialIb = []
        if(this.specialIB.length == 1 && !this.specialIB[0].ibId){
          specialIb = []
        }else{
          this.specialIB.forEach(it=>{
            it.value.forEach(it2=>{
              specialIb.push({ibId: it.ibId,name: it.name,withSub: it.withSub,rebate: it2.rebate,level:it2.level})
            })
          })
        }
        return {
          enable: this.enable,
          salesId: this.$route.query.id,
          updateBy: JSON.parse(sessionStorage.user).user_name,
          rule: this.enable ? this.rule : newRule,
          specialIb,
          ignoreIb: this.overlookIB.length == 1 && !this.overlookIB[0].ibId ? [] : this.overlookIB
        }
      },
      verifyData () { // 提交审核的参数
        return {
          salesId : this.$route.query.id,
          confirmBy: JSON.parse(sessionStorage.user).user_name
        }
      },
    },
    methods: {
      pageInit (version) { // 初始化数据
        let oId = this.$route.query.id
        this.$http.get(api.getUrl20(this.curArea,URL_SALESSET+'/'+version+'/'+oId)).then(res => {
          if (res.data.code == 200 && res.data.msg == 'OK') {
            let data = res.data.data
            this.enable = data.enable
            this.updateBy = data.updateBy
            this.lastUpdate = data.lastUpdate ? updateTimeByUtc(this.UTCDIFF,data.lastUpdate) : data.lastUpdate
            this.confirmBy = data.confirmBy
            this.lastConfirm = data.lastConfirm ? updateTimeByUtc(this.UTCDIFF,data.lastConfirm) : data.lastConfirm
            this.relation = data.relation.slice(0,-1)
            this.rule = data.rule.length > 0 ? data.rule : [
              [
                {
                  ruleId: 4,
                  clientType: 0,
                  value: '',
                  enableCommTarget: false,
                  commTarget: ''
                }
              ]
            ]
            this.currentIB = {
              id: data.salesId,
              name: data.relation[(data.relation.length-1)].name
            }
            let specialData = data.specialIb.length > 0 ? data.specialIb : [{ibId: '',name: '',withSub: true,rebate: '',level:0}]
            // this.specialIB = data.specialIb.length > 0 ? data.specialIb : [{ibId: '',name: '',withSub: true,rebate: ''}]
            let obj = specialData.reduce((a,b)=>{
              if(a[b.ibId]){
                a[b.ibId].value.push({level:b.level,rebate:b.rebate})
              }else{
                a[b.ibId] = {ibId:b.ibId,name:b.name,withSub:b.withSub, value:[]}
                a[b.ibId].value.push({level:b.level,rebate:b.rebate})
              }
              return a
            },{})
            let ret = []
            Object.keys(obj).forEach(it=>{
              obj[it].value = obj[it].value.sort((a,b)=>b.level-a.level)
              ret.push(obj[it])
            })
            this.specialIB = ret
            this.overlookIB = data.ignoreIb.length > 0 ? data.ignoreIb : [{ibId: '',name: '',withSub: true}]
            this.isConfirm = data.isConfirm
            this.ruleSeq = data.ruleSeq
            this.$parent.reqData = data.ruleSeq
            this.salesTemplate = data.salesTemplate
          }
        })
      },
      submit () { // 保存修改
        function isTrueFn(element) { 
          return (element == true)
        }
        let arr = [this.$refs.ruleSetting.$validator.validateAll(),this.$refs.specialAndOverlook.$validator.validateAll()]
        Promise.all(arr).then(result => {
          if (result.every(isTrueFn) && (this.enable ? this.checkRuleResultFn() : true)) {
            this.$http.post(api.getUrl20(this.curArea,URL_SALESSET)+'/1',this.updateData).then(res => {
              if (res.data.code == 200 && res.data.data == "OK" && res.data.msg == "OK") {
                //this.showModal = true
                //this.sucSave = true
                this.$message.success(this.multiLanguage.submitResult.succeed)
                this.updateBy = JSON.parse(sessionStorage.user).user_name
                this.lastUpdate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                this.isConfirm = false
              }
              else {
                //this.showModal = true
                //this.sucSave = false
                this.$message.error(this.multiLanguage.submitResult.serverErr)
              }
            })
          } else {
            this.showModal = true
            this.sucSave = false
          }
        })
      },
      verify () { // 确认修改
        if (!this.updateBy)
          {
            alert(this.multiLanguage.alertMsg.beforeSave)
            return
          }
        else if (this.verifyData.confirmBy == this.updateBy){
          alert(this.multiLanguage.alertMsg.checkFail)
          return
        }else {
          let msg = this.multiLanguage.alertMsg.verifyTips
          if (confirm(msg) == true) {
            this.$http.post(api.getUrl20(this.curArea,URL_SALESSET)+'/0',this.verifyData).then(res => {
              if (res.data.code == 200 && res.data.data == "OK") {
                //this.showModal = true
                //this.sucSave = true
                this.$message.success(this.multiLanguage.submitResult.auditSuccess)
                this.$emit('afterVerify')
                this.isConfirm = true
              }
              else {
                //this.showModal = true
                //this.sucSave = false
                this.$message.error(this.multiLanguage.submitResult.serverErr)
              }
            })
          }
        }
      },
      checkIdFn (ruleItem) { // 检查id是否在关系图
        this.$http(api.getUrl20(this.curArea,URL_TOOLCHECKID),{params:{id: ruleItem.commTarget,type:'SL'}}).then(res => {
          let result = res.data.data.result
          if (!result) {
            alert(this.multiLanguage.alertMsg.noAccount)
            ruleItem.commTarget = ''
          }
        })
      },
      getLengthWithMatch(arr, callback) {
        let len = 0
        arr.forEach(a => {
          len += callback(a) ? 1 : 0
        })
        return len
      },
      hasSameItem(arr, names) {// 数组中的所有项的name属性的值是否都相同
        if (arr.length > 1) {
          let target = arr[0] // 参照物
          for (let i = 1; i < arr.length; i++) {
            if (this.isSameObject(target, arr[i], names)) return true
          }
        }
        return false
      },
      isSameObject(obj1, obj2, properties) {// 判断两个对象的所有properties是否都相同
        for (let p of properties) {
          if (obj1[p] !== obj2[p]) return false
        }
        return true
      },
      checkRuleSetting2(rules) { // 规则设定检查2
        let falseCommTargetLength = this.getLengthWithMatch(rules, r => !r.enableCommTarget)
        if (falseCommTargetLength === 0) return true //规则中没有为false的项
        if (falseCommTargetLength != rules.length) { // enableCommTarget存在不相同
          // alert('分配账号设定不同。')
          alert(this.multiLanguage.alertMsg.checkRuleFail1)
          return false
        } 

        if (this.getLengthWithMatch(rules, r => r.ruleId === 4) > 0) {
          if (this.getLengthWithMatch(rules, r => r.ruleId === 7 || r.ruleId === 8) > 0) {
            // alert('固定金额与固定金额(普通组别)、固定金额(VIP 组别)不能同时选择。')
            alert(this.multiLanguage.alertMsg.checkRuleFail2)
            return false
          }
        }

        let zeroClientTypeLength = this.getLengthWithMatch(rules, r => r.clientType === 0)
        if (zeroClientTypeLength > 0) { // ruleId 不能重复
          if (this.hasSameItem(rules, ['ruleId'])) alert(this.multiLanguage.alertMsg.checkRuleFail3) // alert('相同规则下，全部客户类型与其他客户类型冲突') 
          return !this.hasSameItem(rules, ['ruleId'])
        } else { // 项与项之间的ruleId和clientType不能相同
          if (this.hasSameItem(rules, ['ruleId', 'clientType'])) alert(this.multiLanguage.alertMsg.checkRuleFail4) //alert('存在重复的规则设定')
          return !this.hasSameItem(rules, ['ruleId', 'clientType'])
        }
        return true
      },
      checkRuleSetting1(rule) { // 规则设定检查1
        let checkRule = {}
        for (let val of rule) {
          for (let r of val) {
            if (r.ruleId == 5) {
              if (!checkRule[`${r.ruleId}-clientType`]) {
                checkRule[`${r.ruleId}-clientType`] = { count: 1, content: JSON.stringify({ clientType: r.clientType }) }
              } else {
                if (JSON.stringify({ clientType: r.clientType }) != checkRule[`${r.ruleId}-clientType`].content) {
                    return false
                } else {
                    checkRule[`${r.ruleId}-clientType`].count++
                }
              }
            }
          }
        }
        for (let key in checkRule) {
          if (checkRule[key].count != rule.length) { 
            //alert('存在“分层最高金额”这个规则时，每个级别都必须有一条“分层最高金额”，并保证“客户类型”一致')
            alert(this.multiLanguage.alertMsg.checkRuleFail5)
            return false
          }
        }
        return true
      },
      checkRuleResultFn() {
        let result = []
        for (let rule of this.updateData.rule) {
          result.push(this.checkRuleSetting2(rule))
        }
        if (result.every(r => r === true) && this.checkRuleSetting1(this.updateData.rule)) {
          // console.log('1_',result,this.checkRuleSetting1(this.updateData.rule))
          return true
        }
        else {
          // console.log('2_',result,this.checkRuleSetting1(this.updateData.rule))
          return false
        }
      },
      normSetFn (path) {// 拿到内设数据
        this.$http.get(api.getUrl20(this.curArea,URL_DEFAULT)+path).then((res) => {
          if (res.data.code === 200) {
              this.rule = res.data.data.rulemapping
          }
        })
      },
    },
    watch: {
      curArea () {
        this.pageInit(this.version)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .commissionDatum{
    input[type='checkbox']{
      vertical-align: middle;
      margin-top: 0;
    }
    .title{
      position: relative;
      border-bottom: 2px solid #3F51B5;
      input[type='checkbox']{
        width: 22px;
        height: 22px;
      }
      span{
        color: #3F51B5;
        font-weight: 550;
        font-size: 15px;
      }
      .enable-btn{
        width: 15px;
        height: 15px;
      }
      .enable-text{
        font-size: 16px;
        font-weight: 700;
        color: #F08712;
      }
      .table-title{
        font-size: 20px;
        margin-left: 20px;
      }
      .btn-box{
        height: 50px;
        button{
          margin-left: 10px;
          background-color: #3f51b5;
          color:#fff;
        }
        span{
          color: #fff;
        }
      }
    }
    .last-update-box{
      margin-top: 20px;
      text-align: right;
      color: #3f51b5;
      font-weight: 550;
      font-size: 16px;
    }
    .cpa-switch-box{
      margin: 5px 0 10px;
      .cpa-switch{
        .internal{
          border-radius: 3px 0 0 3px;
        }
        .CPA{
          border-radius: 0;
          margin-left: -4px;
        }
        .internalAndCPA{
          border-radius: 0 3px 3px 0;
          margin-left: -5px
        }
        .active{
          background-color: #3F51B5!important;
          color: #fff!important;
        }
        .default-color{
          color: #333;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// saleCommissionContent.vue?e1fdcb58